import { Component, inject, OnInit } from '@angular/core';
import { CategoryService, ProductCatalogService } from 'shared';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  private readonly catalog = inject(ProductCatalogService);
  private readonly catService = inject(CategoryService);

  title = 'portal';

  ngOnInit(): void {
    this.catalog.loadPage();
    this.catService.loadAll();
  }
}
